import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { KeyCode } from '../../constants/keyCodes'
import { isSingleKey } from './KeyShortcutsService'
import { actions } from '../../store/botNames/botNamesSlice'
import { startListening, stopListening } from './keyDownListener'
import { useIsOpenAddStepMenu } from '../../store/stepCreationMenu'

export const KeyCodeB: React.FC = () => {
  const dispatch = useDispatch()
  const isOpenAddStepMenu = useIsOpenAddStepMenu()

  useEffect(() => {
    startListening(KeyCode.B, (event: KeyboardEvent) => {
      if (isOpenAddStepMenu) {
        return
      }

      if (isSingleKey(event)) {
        dispatch(actions.setFocus(true))
      }

      event.preventDefault()
    })

    return () => {
      stopListening(KeyCode.B)
    }
  }, [isOpenAddStepMenu, dispatch])

  return null
}
